import { useEffect, useState } from 'react';

import { getSiteContent } from '../../../services/api';
import AboutUsLayout from '../../AboutUsLayout';
import './Contact.css';

export default function Contact() {
  const [contacts, setContacts] = useState([]);
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await getSiteContent();
        if (data.length > 0) {
          const item = data[0];
          setContacts(item.contacts || []);
          if (item.address || item.locationName || item.mapsLink || item.institutionalEmail) {
            setLocation({
              address: item.address || '',
              locationName: item.locationName || '',
              mapsLink: item.mapsLink || '',
              institutionalEmail: item.institutionalEmail || '',
            });
          }
        }
      } catch {
        // mantém estado vazio
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <AboutUsLayout activePage="contato">
        <main className="home-main" />
      </AboutUsLayout>
    );
  }

  return (
    <AboutUsLayout activePage="contato">
      <main className="home-main">
        <h1 className="contact-page-title">Contato</h1>

        {/* Equipe */}
        {contacts.length > 0 && (
          <section className="contact-section">
            <h2 className="contact-section-title">Equipe</h2>
            <div className="contact-grid">
              {contacts.map((pessoa, i) => (
                <article className="contact-card" key={i}>
                  <div className="contact-avatar contact-avatar-initial">
                    <span className="contact-avatar-letter">
                      {pessoa.name.trim().charAt(0).toUpperCase()}
                    </span>
                  </div>
                  <div className="contact-info">
                    <span className="contact-nome">{pessoa.name}</span>
                    {pessoa.role && <span className="contact-cargo">{pessoa.role}</span>}
                    {pessoa.email && (
                      <span className="contact-email">
                        <svg
                          className="email-icon"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect x="2" y="4" width="16" height="12" rx="2" stroke="#888" strokeWidth="1.4" />
                          <path d="M2 7l8 5 8-5" stroke="#888" strokeWidth="1.4" strokeLinecap="round" />
                        </svg>
                        {pessoa.email}
                      </span>
                    )}
                  </div>
                </article>
              ))}
            </div>
          </section>
        )}

        {/* Localização */}
        {location && (
          <section className="contact-localizacao-card">
            <h2 className="contact-localizacao-title">Localização</h2>

            {location.address && (
              <p className="contact-localizacao-text">
                <strong>Endereço:</strong> {location.address}
              </p>
            )}

            {(location.locationName || location.mapsLink) && (
              location.mapsLink ? (
                <a
                  href={location.mapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-maps-link"
                >
                  Localizado em: {location.locationName || 'Ver localização'} &mdash; Ver no Google Maps
                </a>
              ) : (
                <p className="contact-localizacao-text">
                  <strong>Localizado em:</strong> {location.locationName}
                </p>
              )
            )}

            {location.institutionalEmail && (
              <p className="contact-localizacao-text contact-localizacao-email">
                <strong>E-mail Institucional:</strong> {location.institutionalEmail}
              </p>
            )}
          </section>
        )}
      </main>
    </AboutUsLayout>
  );
}
